import "htmx.org";

window.htmx = require("htmx.org");
